$(document).ready(function () {
    // Policy Check Start needhelpChat
    var modal = document.querySelector('.cookies-overlay');
    var needHelp = document.querySelector('.needhelpChat');
    if (!readCookie('hideCookiePolicy')) {
        window.addEventListener('load', (event) => {
            modal.classList.add('loaded');
        });
        
    }
    window.addEventListener('load', (event) => {
        needHelp.classList.add('loaded');
    });
    

    $('.close-cookie-button').click(function (e) {
        modal.classList.remove('loaded');
        e.stopPropagation();
        createCookie('hideCookiePolicy', true, 1)
        return false;
    });
    // Policy Check End

    function owl_carousl_call($owl) {
        $owl.owlCarousel({
            nav: false,
            dots: false,
            items: 6,
            margin: 23,
            autoWidth: true,
            navText: [
                "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
                "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
            ],
            responsive: {
                0: {
                    items: 1.2
                },
                1025: {
                    items: 3.5,
                    nav: true
                }
            },
            onTranslated: showPrev,
            onDraged: showPrev,
            onInitialized: currentItem,
            onRefresh: currentOnHover
        });
    }

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else {
            var expires = "; expires=0";
        }
        console.log(name + "=" + value + expires + "; path=/");
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            // console.log(nameEQ);
            // console.log(c);
            // console.log(c.indexOf(nameEQ));
            // console.log(c.substring(nameEQ.length,c.length));
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    function socialFeedGridViewFn() {
        let grids = [...document.querySelectorAll('.grid')];
        if (grids.length && getComputedStyle(grids[0]).gridTemplateRows !== 'masonry') {
            grids = grids.map(grid => ({
                _el: grid,
                gap: parseFloat(getComputedStyle(grid).gridRowGap),
                items: [...grid.childNodes].filter(c => c.nodeType === 1),
                ncol: 0
            }));
            function layout() {
                grids.forEach(grid => {
                    /* get the post relayout number of columns */
                    let ncol = getComputedStyle(grid._el).gridTemplateColumns.split(' ').length;

                    /* if the number of columns has changed */
                    if (grid.ncol !== ncol) {
                        /* update number of columns */
                        grid.ncol = ncol;

                        /* revert to initial positioning, no margin */
                        grid.items.forEach(c => c.style.removeProperty('margin-top'));

                        /* if we have more than one column */
                        if (grid.ncol > 1) {
                            grid.items.slice(ncol).forEach((c, i) => {
                                let prev_fin = grid.items[i].getBoundingClientRect().bottom /* bottom edge of item above */,
                                    curr_ini = c.getBoundingClientRect().top /* top edge of current item */;

                                c.style.marginTop = `${prev_fin + grid.gap - curr_ini}px`
                            })
                        }
                    }
                })
            }
            layout();
        }
    }

    $(document).on("click", '.show-more', function (e) {
        e.preventDefault();
        var type = $(this).data('show-all');
        var socialproofSlides = '';
        $(this).toggleClass('active');
        $.ajax({
            type: "GET",
            url: assetBaseUrl + "show-social-proof/" + type,
            beforeSend: function (data) {
                $('#loader').css('display', 'block');
            },
            success: function (data) {
                $('#loader').css('display', 'none');
                if (data.error) {
                    sweetErrorPopUpWithTitle(data.msg);
                } else {
                    $.each(data.socialProofs, function (key, value) {
                        if (typeof (value.type) != "undefined") {
                            if (value.type === 'fb') {
                                var iconImg = 'social-fb-rounded.svg';
                            } else {
                                var iconImg = 'social-insta-rounded.svg';
                            }
                        }
                        socialproofSlides += '<div class="item"><div class="item-inner">' +
                            '<div class="img-container">' +
                            '<img class="post-img" src="' + value.image + '"alt="tab_img">' +
                            '<div class="auther-profile-link"><a><img src="' + assetBaseUrl + '/images/' + iconImg + '" alt="auther-profile-link"></a></div>' +
                            '</div><div class="post-des">' + value.content + '</div></div></div>';
                    });
                    $('.grid').html(socialproofSlides);
                    $(".show-more").text(data.show_text);
                    $(".show-more").data('show-all', data.show_type);
                    socialFeedGridViewFn();
                }
            }
        });
    });

    $(document).on("click", '.country-resorts', function (e) {
        var popularSlides = new LazyLoad(
            { container: document.querySelector('#popular-slides') }
        );
        e.preventDefault();
        e.stopImmediatePropagation();
        $('.country-resorts').removeClass("active");
        $(this).addClass('active');
        var country = $(this).data('country');
        var resortSlides = '';
        $.ajax({
            type: "GET",
            url: assetBaseUrl + "country-wise-resorts/" + country,
            beforeSend: function (data) {
                $('#loader').css('display', 'block');
            },
            success: function (data) {
                $('#loader').css('display', 'none');
                if (data.status) {
                    if (data.resortData.length > 0) {
                        var res;
                        var add_text;
                        $.each(data.resortData, function (key, value) {
                            if (key < 6) {
                                console.log(value.resort_name);
                                if (typeof (value.city_name) != "undefined" && typeof (value.state_name) != "undefined") {
                                    res = value.city_name + ', ' + value.state_name;
                                } else {
                                    res = value.country_name;
                                }
                                if (value.additional_text) {
                                    add_text = '<div class="img-text">' + '<strong>' + value.additional_text + '</strong></div>';
                                } else {
                                    add_text = '';
                                }
                                resortSlides += '<div onclick="resortCardClicked(\'Landing Page\',\'' + value.resort_name + '\',\'' + res + '\',\'' + value.country_name + '\');" class="popular-slide" style="width: 267px;">' +
                                    '<div class="img-container">' +
                                    '<a href=' + assetBaseUrl + "resort/" + value.slug + '><img class="lazy" data-src="' + data.img_base_url + value.resort_banner + '" alt="' + value.alt + '"></a>' +
                                    add_text + '</div>' +
                                    '<div class="btm-img-text">' +
                                    '<strong>' + value.resort_name + '</strong>' +
                                    '<span>' + res + '</span></div></div>';
                            }
                        });
                        $('.resort-filter-slide').html(resortSlides);
                    } else {
                        resortSlides = '<i>There is no record found !</i>'
                        $('.resort-filter-slide').html(resortSlides);
                        console.log("no record found !");
                    }
                }
                var $owl = $('#popular-slides');
                $owl.trigger('destroy.owl.carousel');
                $owl.html($owl.find('.owl-stage-outer').html()).removeClass('owl-loaded');
                owl_carousl_call($owl);
                $(".btm-img-text").matchHeight();
                // After your content has changed...
                popularSlides.update();
            }
        });
    });

    $(document).on('mouseenter', '.dis-slide', function () {
        if ($(this).parent('.currentOnHover').length) {
            var posterImg = $(this).find('.poster-img').val();
            var mobilePosterImg = $(this).find('.mobile-poster-img').val();
            var webpPosterImg = $(this).find('.webp-poster-img').val();
            var webpMobilePosterImg = $(this).find('.webp-mobile-poster-img').val();
            var videoUrl = $(this).find('.video-url').val();           
            $('.poster-img').attr('src', posterImg);
            $('.web-poster').attr('srcset', posterImg);
            $('.web-poster-webp').attr('srcset', webpPosterImg);
            $('.mob-poster').attr('srcset', mobilePosterImg);
            $('.mob-poster-webp').attr('srcset', webpMobilePosterImg);
            $('.dis-p-icon').data('src', videoUrl);            
        }
    });

    $(document).on('click', '.dis-p-icon', function (e) {
        e.preventDefault();
        var target = $(this).data('src');
        $.fancybox.open({
            src: target,
            type: 'iframe',
            opts: {
                baseClass: "map360container",
                afterShow: function (instance, current) {
                    console.info('done!', current);
                }
            }
        });
    });

    var lastScrollTop = 500;
    var loaded = false;
    var socialFeedloaded = false;
    var st = $(this).scrollTop();
    console.log("scrollTop == ",st);
    if (st > (lastScrollTop * .5) && !fancyBoxJsload) {
        fancyBoxJs();
    }
    if (document.getElementById('on-scroll-section')) {
        $(window).scroll(function () {
            st = $(this).scrollTop();
            if (st > (lastScrollTop * .5) && !fancyBoxJsload) {
                fancyBoxJs();
            }
            if (st > (lastScrollTop * 2) && !loaded) {
                var onScrollSection = new LazyLoad(
                    { container: document.getElementById('on-scroll-section') }
                );
                if (loaded) return;
                else {
                    frontNonCriticalCss();
                    $.ajax({
                        type: "GET",
                        url: assetBaseUrl + "load-persona-data",
                        success: function (data) {
                            if (data.error) {
                                sweetErrorPopUpWithTitle(data.msg);
                            } else {
                                $('#on-scroll-section').html(data.html);
                                owl_carousl_call($('#popular-slides'));
                                owl_carousl_call($('#complimentary-offers'));
                                owl_carousl_call($('#thumb360'));
                                onScrollSection.update();
                                if ($(".complimentary-offers").length > 0) {
                                    $(".complimentary-offers .slide-content").matchHeight();
                                }
                            }
                        }
                    });
                    loaded = true;
                }
            }
//            if (st > (lastScrollTop * 6) && !socialFeedloaded) {
//                var followupSection = new LazyLoad(
//                    { container: document.getElementById('on-scroll-socialFeed') }
//                );
//                if (socialFeedloaded) return;
//                else {
//                    frontNonCriticalCss();
//                    $.ajax({
//                        type: "GET",
//                        url: assetBaseUrl + "social-feeds",
//                        success: function (data) {
//                            if (data.error) {
//                                sweetErrorPopUpWithTitle(data.msg);
//                            } else {
//                                $('#on-scroll-socialFeed').html(data.html);
//                                followupSection.update();
//                                socialFeedGridViewFn();
//                            }
//                        }
//                    });
//                    socialFeedloaded = true;
//                }
//            }
        });
    }


            /* Header scroll js*/
            $(window).scroll(function(){
                if ($(this).scrollTop() > 10) {
                    $('#mainHeader').addClass('fixed');
                }
                    else {
                   $('#mainHeader').removeClass('fixed');
                }
            });
            /* Header scroll js*/

});